/**
 * Resolve the backend API base URL for every API client.
 *
 *  - REACT_APP_API_URL when set at build time (explicit override).
 *  - On localhost (CRA dev server on :3112) → the local backend on :3209.
 *  - Otherwise (deployed: the SPA is served BY the backend container, e.g. App
 *    Runner) → same origin, so calls go to the same host that served the page.
 *
 * The old hard-coded `|| 'http://localhost:3209'` fallback broke the deployed
 * site (every API call pointed at localhost), which is why editor saves and the
 * mobile player's library never reached the live backend.
 */
export function getApiBase(): string {
  const env = process.env.REACT_APP_API_URL;
  if (env) return env.replace(/\/$/, '');
  if (typeof window !== 'undefined') {
    const h = window.location.hostname;
    if (h === 'localhost' || h === '127.0.0.1') return 'http://localhost:3209';
  }
  return ''; // same origin
}

/** Convenience constant (resolved once at module load). */
export const API_BASE = getApiBase();
